const initialState = {
  error: null,
  authUser: {
    username: null,
    sub_plan: "Free Plan",
    role_name: "Basic Customer",
    role_id: 2,
    allowed: [
      "COMPARE",
      "VIEW_DYNAMIC_GRAPH",
      "FINANCIAL_VIEW",
      "STOCK_SCREENER_VIEW",
      "MARKET_HEATMAP_VIEW",
      "TECHNICAL_ANALYSIS_VIEW",
    ],
  },
  alert: null,
  baseCurrency: "LKR",
  selectedMarketId: 1,
};

export default initialState;
